import api from './api';

export let meta_value = undefined;


export interface Trademark {
  id?: number;
  user_id?: number;
  client_id?: number;
  user_email?: string;
  nation?: string;
  name?: string;
  application_no?: string;
  owner_name?: string;
  status?: string;
  condition?: string;
  registration_no?: string;
  attorney_name?: string;
  attorney_email?: string;
  correspondent_name_address?: string;
  correspondent_email?: string;
  remote_status?: string;
  application_date?: string;
  application_at?: string;
  registration_date?: string;
  expiry_date?: string;
  renewal_date?: string;
  class_no?: string;
  goods_services?: string;
  applicant_name?: string;
  agent_name?: string;
  priority_date?: string;
  priority_country?: string;
  priority_no?: string;
  publication_date?: string;
  opposition_period_end?: string;
  history?: string;
  documents?: string;
  primary_class?: string;
  sub_class?: string;
  image?: string;
  status_updated_at?: string;
  next_update_at?: string;
  due_at?: string;
  approve_at?: string;
  created_at?: string;
  updated_at?: string;
  metas?: Array<{ meta_key: string; meta_value: string }>;
}

export interface TrademarkListParams {
  page?: number;
  per_page?: number;
  search?: string;
  status?: string;
  nation?: string;
  // 所属人筛选（仅管理员可用）
  user_id?: number;
}

export interface TrademarkListResponse {
  success: boolean;
  data: {
    data: Trademark[];
    current_page: number;
    last_page: number;
    per_page: number;
    total: number;
  };
}

export interface TrademarkResponse {
  success: boolean;
  message?: string;
  data?: Trademark;
  errors?: any;
}

export interface MonitorStatusResponse {
  success: boolean;
  data: {
    is_monitored: boolean;
    trademark_id?: number;
    status?: string;
  };
}

export interface AddFromOrderRequest {
  application_no: string;
  user_email: string;
  nation: string;
  client_id?: number;
}

class TrademarkService {
  // 获取筛选选项（如所属人，来自 trademark 表去重）
  async getFilterOptions(): Promise<{ success: boolean; data: { owners: Array<{ value: number; label: string }> } }> {
    const response = await api.get('/trademarks/filter-options');
    return response.data;
  }

  // 获取商标列表
  async getTrademarks(params?: TrademarkListParams): Promise<TrademarkListResponse> {
    const response = await api.get('/trademarks', { params });
    return response.data;
  }

  // 创建商标
  async createTrademark(trademarkData: Trademark): Promise<TrademarkResponse> {
    const response = await api.post('/trademarks', trademarkData);
    return response.data;
  }

  // 获取商标详情
  async getTrademark(id: number): Promise<TrademarkResponse> {
    const response = await api.get(`/trademarks/${id}`);
    return response.data;
  }

  // 更新商标
  async updateTrademark(id: number, trademarkData: Trademark): Promise<TrademarkResponse> {
    const response = await api.put(`/trademarks/${id}`, trademarkData);
    return response.data;
  }

  // 删除商标
  async deleteTrademark(id: number): Promise<{ success: boolean; message: string }> {
    const response = await api.delete(`/trademarks/${id}`);
    return response.data;
  }

  // 批量删除商标
  async batchDeleteTrademarks(ids: number[]): Promise<{ success: boolean; message: string; data?: { deleted_count: number } }> {
    const response = await api.post('/trademarks/batch-delete', { ids });
    return response.data;
  }

  // 同步商标状态
  async syncStatus(id: number): Promise<TrademarkResponse> {
    const response = await api.post(`/trademarks/${id}/sync-status`);
    return response.data;
  }

  // 检查申请号监控状态
  async checkMonitorStatus(applicationNo: string): Promise<MonitorStatusResponse> {
    const response = await api.post('/trademarks/check-monitor-status', {
      application_no: applicationNo
    });
    return response.data;
  }

  // 从订单添加到商标监控
  async addFromOrder(data: AddFromOrderRequest): Promise<TrademarkResponse> {
    const response = await api.post('/trademarks/add-from-order', data);
    return response.data;
  }
}

const trademarkService = new TrademarkService();
export default trademarkService;
